import styled from '@emotion/styled';
import { IconButton, IconButtonProps } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

const CloseButtonContainer = styled(IconButton)`
  position: absolute;
  right: 5px;
  top: 5px;
  color: ${({ theme }) => theme.palette.common.midnight};
  z-index: 99;
`;

export type CloseButtonProps = IconButtonProps & {
  children?: React.ReactNode | React.ReactNode[] | string;
};

export const CloseButton = ({ children, ...props }: CloseButtonProps): React.ReactElement => {
  return <CloseButtonContainer {...props}>{children || <CloseIcon />}</CloseButtonContainer>;
};
